import React from "react";
import "../../styles/services.css";
import { useTranslation } from "react-i18next";

const Services = () => {
  const { t } = useTranslation();

  const servicesData = [
    {
      icon: "ri-apps-line",
      title: "APP_DEVELOPMENT",
      desc: "APP_DEVELOPMENT_DESC",
    },
    {
      icon: "ri-code-s-slash-line",
      title: "WEB_DEVELOPMENT",
      desc: "WEB_DEVELOPMENT_DESC",
    },
    {
      icon: "ri-brush-line",
      title: "GRAPHIC_DESIGN",
      desc: "GRAPHIC_DESIGN_DESC",
    },
    {
      icon: "ri-megaphone-line",
      title: "DIGITAL_MARKETING",
      desc: "DIGITAL_MARKETING_DESC",
    },
  ];

  return (
    <section id="services">
      <div className="container">
        <div className="services-top-content">
          <h6 className="subtitle">{t("OUR_SERVICES")}</h6>
          <h2>{t("SERVICES_TITLE_1")}</h2>
          <h2 className="highlight">{t("SERVICES_TITLE_2")}</h2>
        </div>

        <div className="services-wrapper">
          {servicesData.map((item, index) => (
            <div className="services-item" key={index}>
              <span className="service-icon">
                <i className={t(item.icon)}></i>
              </span>
              <h3 className="service-title">{t(item.title)}</h3>
              <p className="description">{t(item.desc)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
